import { setupDefaultState } from '@alme/ui-web/wireup/default-state';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { settings } from '@alme/ui-web/settings/settings-util';

function setupState(components, onContactUsPage) {
    const defaultState = setupDefaultState(components);
    
    if(onContactUsPage){
        defaultState[settings.stateLocations.Window.position] = {};
        defaultState[settings.stateLocations.Window.size] = {};
    }
    //defaultState[settings.stateLocations.Conversation.processedResponse]= null,
    defaultState[settings.stateLocations.LiveChat.Base] = {
        //foundational settings
        [settings.stateLocations.LiveChat.sessionState]: settings.livechat.sessionState.offline,
        [settings.stateLocations.LiveChat.operatorData]: [],
        [settings.stateLocations.LiveChat.LastSeenIndex]: -1,
        [settings.stateLocations.LiveChat.queueText]: "",
    },
    defaultState[settings.stateLocations.FormInteraction.Base] = {};
    defaultState[settings.stateLocations.Survey.Base] = {
        reason: "",
        comment: "",
        [settings.stateLocations.Survey.MetaData]: {},
    };

    return defaultState;
}

export {
    setupState
};


// WEBPACK FOOTER //
// ./src/setup-state.js